import React from 'react';
import { services } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const ServicesSection = () => (
  <section className="py-10 bg-zinc-950" id="services">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
          Services de Maraboutage Africain
        </h2>
        <p className="text-base md:text-lg text-amber-100/70">Rituels traditionnels puissants et efficaces</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto">
        {services.slice(0, 8).map((service) => (
          <Card
            key={service.id}
            className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20"
          >
            <CardContent className="p-4 md:p-6 text-center">
              <div className="text-3xl md:text-4xl mb-3">{service.icon}</div>
              <h3 className="text-sm md:text-lg font-bold text-amber-400">{service.title}</h3>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
